var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeclarer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30.4 42",
    style: {
      enableBackground: "new 0 0 30.4 42"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M30.1,6.9c0-1-0.4-1.4-1.4-1.4h-5.1c-0.6-1.2-1.8-2-3.2-2.2c-0.5-0.1-0.9-0.1-1.3-0.1l-0.4,0 c-0.1,0-0.1,0-0.2,0c0,0,0-0.1,0-0.2c-0.2-1.7-1.5-2.9-3.2-2.9c-1.6,0-3,1.2-3.2,2.9c0,0.1,0,0.1,0,0.2c0,0-0.1,0-0.2,0l-0.5,0 c-0.4,0-0.8,0-1.3,0.1C8.8,3.5,7.6,4.3,7,5.5l-5.4,0c-1.1,0-1.4,0.4-1.4,1.4v33.5c0,1,0.4,1.4,1.4,1.4h27.1c1,0,1.4-0.4,1.4-1.4 l0-24.8L30.1,6.9z M11.4,5.4l0.5,0c1.4,0,2.2-0.7,2.3-2.1c0.1-0.6,0.5-1,1-1c0.5,0,1,0.4,1,1c0.2,1.4,0.9,2.1,2.4,2.1l0.5,0 c0.4,0,0.7,0,1,0c1,0.1,1.7,0.9,1.8,1.9c0,0.2,0,0.3,0,0.5H8.6c0-0.2,0-0.3,0-0.5v0c0.1-1,0.8-1.7,1.8-1.9 C10.7,5.4,11.1,5.4,11.4,5.4z M24.2,10l-0.1-1.7c0-0.2,0-0.4,0-0.6l3.7,0v31.9H2.4V7.8l4,0c0,0.2,0,0.4,0,0.6L6.3,10H24.2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeclarer);
export default __webpack_public_path__ + "static/media/Declarer.585aeb85.svg";
export { ForwardRef as ReactComponent };